import { render, staticRenderFns } from "./gallerySalesLimit.vue?vue&type=template&id=58bc1f6f&scoped=true"
import script from "./gallerySalesLimit.vue?vue&type=script&lang=js"
export * from "./gallerySalesLimit.vue?vue&type=script&lang=js"
import style0 from "./gallerySalesLimit.vue?vue&type=style&index=0&id=58bc1f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc1f6f",
  null
  
)

export default component.exports